<template>
  <a
    :href="item.url"
    class="flex flex-col sm:flex-row gap-4 h-full w-[calc(100%-1px)]"
    target="_blank"
    @click="sourceOnClick"
  >
    <UAvatar
      v-if="item.image"
      class="aspect-[4/3] rounded-md border border-gray-84 sm:w-40"
      :src="item.image"
      :alt="`${item.url} - illustrative photo`"
    />
    <div>
      <div class="text-sm text-dlubal-blue font-semibold line-clamp-2 md:line-clamp-1">
        {{ item.title }}
      </div>
      <p class="text-sm my-2 line-clamp-3 md:line-clamp-2">
        {{ item.description }}
      </p>
    </div>
  </a>
</template>

<script setup lang="ts">
import UAvatar from '@/components/ui/UAvatar.vue'
import { BaseApiCitation } from '@/types/api'
import Clarity from '@microsoft/clarity'

export interface ChatCarouselItemProps {
  item: BaseApiCitation
}

const props = defineProps<ChatCarouselItemProps>()

const sourceOnClick = () => {
  Clarity.event('clickedSource')
  Clarity.setTag('citationId', String(props.item.id))
}
</script>
